const modifyHolidays = (dates = []) => {
  if (!dates || dates.length === 0) return [];
  return dates.map((h) => {
    const dt = new Date(h.date);
    return new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1000);
  });
};

export default modifyHolidays;
